import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import LoginPage from "./modules/login/views/Pages/LoginPage.jsx";
import App from "./views/layouts/App";
import { connect } from "react-redux";
import { updateUser } from "./store/actions/authActions";
import ls from "localstorage-slim";

class RouteApp extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (ls.get("token")) {
      this.props.updateUser();
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }

    return <Router>{!this.props.user.token ? <LoginPage /> : <App />}</Router>;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {
  updateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteApp);
